import React from "react";
import type { InteractionDialogProps } from "../DialogBase";
import { DialogBase } from "../DialogBase";
import { onCloseDialog } from "../util";
import { InteractionButtons } from "./InteractionButtons";

export const Confirmation = ({
  title,
  onClose,
  open,
  children,
  ariaLabelCloseIcon,
  onDismissFocusRef,
  icon,
  illustration,
  Illustration,
  dataTestId,
  hideCloseButton,
  width,
  alignIllustration,
  ariaLabel,
  dialogAlignment,
  drawerSize,
  ...interactionProps
}: InteractionDialogProps): React.JSX.Element | null => {
  const closeHandler = (): void =>
    onCloseDialog({ onDismissFocusRef, onClose });

  if (!open) {
    return null;
  }

  return (
    <DialogBase
      ariaLabel={ariaLabel}
      open={open}
      title={title}
      onClose={closeHandler}
      ariaLabelCloseIcon={ariaLabelCloseIcon}
      onDismissFocusRef={onDismissFocusRef}
      icon={icon}
      illustration={illustration}
      Illustration={Illustration}
      dataTestId={dataTestId}
      hideCloseButton={hideCloseButton}
      width={width}
      alignIllustration={alignIllustration}
      dialogAlignment={dialogAlignment}
      drawerSize={drawerSize}
    >
      {children}
      <InteractionButtons
        type="confirmation"
        onClose={closeHandler}
        onConfirm={interactionProps.onConfirm}
        onCancel={interactionProps.onCancel ?? closeHandler}
        actionText={interactionProps.actionText}
        actionDisabled={interactionProps.actionDisabled}
        cancelText={interactionProps.cancelText}
        actionIcon={interactionProps.actionIcon}
      />
    </DialogBase>
  );
};
